import { Controller } from "@hotwired/stimulus"

// Modeling performance report wizard — companion to the generic v2-stepper.
// Handles source selection, mappings frame loading, and per-step validation.
export default class extends Controller {
  static targets = [
    "sourceRadio",
    "mappingsFrame",
    "lowStart",
    "highEnd",
    "name",
  ]
  static outlets = ["v2-stepper"]

  sourceSelected(event) {
    const frame = this.hasMappingsFrameTarget ? this.mappingsFrameTarget : null
    if (frame?.dataset.baseUrl) {
      frame.src = frame.dataset.baseUrl + "?data_source_id=" + event.currentTarget.value
    }
  }

  validate(event) {
    const step = event.detail.step
    let valid = true

    switch (step) {
      case 1:
        valid = this.sourceRadioTargets.some((r) => r.checked)
        break
      case 3: {
        const [from, to] = this._dateValues()
        valid = !!(from && to)
        break
      }
      case 5:
        valid = this.nameTarget.value.trim().length > 0
        break
    }

    if (!valid) event.preventDefault()
  }

  stepChanged(event) {
    const stepper = this.v2StepperOutlet
    if (!stepper) return

    for (let i = 1; i < event.detail.step; i++) {
      stepper.setSummary(i, this.summaryForStep(i))
    }
  }

  summaryForStep(step) {
    switch (step) {
      case 1: {
        const selected = this.sourceRadioTargets.find((r) => r.checked)
        if (!selected) return ""
        const label = selected.closest("label")?.querySelector("[data-source-name]")
        return label ? label.textContent.trim() : selected.value
      }
      case 2:
        return "Mappings reviewed"
      case 3: {
        const [from, to] = this._dateValues()
        return (from && to) ? `${from} to ${to}` : ""
      }
      case 4:
        return `Low ${this.lowStartTarget.value} → High ${this.highEndTarget.value}`
      case 5:
        return this.nameTarget.value
      default:
        return ""
    }
  }

  // V2::DateRangePickerComponent renders its own hidden inputs and exposes
  // them via [data-date-range-picker-target="dateFrom"|"dateTo"]. We read
  // those rather than coupling to the form scope's input names.
  _dateValues() {
    const root = this.element
    return [
      root.querySelector('[data-date-range-picker-target="dateFrom"]')?.value,
      root.querySelector('[data-date-range-picker-target="dateTo"]')?.value,
    ]
  }
}
